const API_URL = '/api/kardex';

/**
 * Obtiene todos los movimientos del inventario (Kardex)
 */
export const getHistorialKardex = async () => {
    try {
        const response = await fetch(API_URL, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            throw new Error('Error al obtener los movimientos del Kardex');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en KardexService:", error);
        throw error;
    }
};